import React from "react";
import { Typography, Paper } from "@material-ui/core";
import { Resizable } from "re-resizable";
import { useTranslation } from "../../langs/useTranslation";
import { BreadCrumbs } from "../../components/device/BreadCrumbs";
import useStyles from "../../styles/groupsStyle";

import Category from "./Category";
import GroupDevicesProvider from "./Provider";
import DevicesList from "./DevicesList";
import DeviceTags from "./DeviceTags";

const GroupsDevices = () => {
  const { t } = useTranslation("groups");
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs pageName="groups" />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">{t("common.groups")}</Typography>
      </div>
      <div className={classes.groupWrapper}>
        <GroupDevicesProvider>
          <Resizable
            defaultSize={{
              minWidth: 250,
              width: 300
            }}
            enable={{
              top: false,
              right: true,
              bottom: false,
              left: false,
              topRight: false,
              bottomRight: false,
              bottomLeft: false,
              topLeft: false
            }}
            className={classes.sizableGroupWrapper}
          >
            <Paper elevation={0} className={classes.sizableGroupList}>
              <Category />
              <DeviceTags />
            </Paper>
          </Resizable>
          <DevicesList />
        </GroupDevicesProvider>
      </div>
    </>
  );
};

export default GroupsDevices;
